module.exports = __webpack_public_path__ + "img/lw-cam.50a6cd7f.jpg";